import config from "src/common/config";
import "./index.css";

export const TicketComponent = ({ reviewTaskTicket }) => {
  return (
    <div>
      {reviewTaskTicket ? (
        <>
          <a
            href={config.zendeskDomainUrl + reviewTaskTicket.id}
            target="_blank"
            rel="noreferrer"
            className={"review-ticket-id"}
          >
            #{reviewTaskTicket.id}
          </a>
          <div className={statusClass(reviewTaskTicket.status)}>
            {convertStatus(reviewTaskTicket.status)}
          </div>
        </>
      ) : (
        <>--</>
      )}
    </div>
  );
};

const convertStatus = (status) => {
  let str = status.toLowerCase();
  return str.replace(str[0], str[0].toUpperCase());
};

const statusClass = (status) => {
  if (status === "CLOSED" || status === "SOLVED") {
    return "review-ticket-close-status";
  } else {
    return "review-ticket-open-status";
  }
};
